export enum FieldNamesEnum {
  firstname = 'Prénom',
  lastname = 'Nom',
  email = 'E-mail',
  password = 'Mot de passe',
  birthdate = 'Date de naissance',
  phone = 'Numéro de téléphone',
  gender = 'Civilité'
}
